export const CHART_CONSTANTS = {
	HEIGHT: 400,
	COLORS: {
		CRITICAL: 'var(--critical)',
		SERIOUS: 'var(--serious)'
	},
	EXCLUDED_FIELDS: ['total'] as string[],
	HEADING_LEVEL: 3,
	Y_AXIS_TITLE: 'Number of Issues',
	WHOLE_NUMBER_THRESHOLD: 6
} as const;

export const CHART_TEXT = {
	TITLE: 'Issues over time',
	NO_DATA_MESSAGE: 'No issues data available',
	TABLE_COLUMNS: {
		DATE: 'Date',
		CRITICAL: 'Critical',
		SERIOUS: 'Serious',
		TOTAL: 'Total'
	},
	TOOLTIP: {
		DATE_LABEL: 'Date:'
	}
} as const;
